import Slider from "react-slick";
import React, { useState, useEffect } from 'react'
import Skeleton from "@material-ui/lab/Skeleton";
import Box from '@material-ui/core/Box';
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    imageHolder: {
        backgroundColor: "#e3e3e3",
        width: "100%",
        height: "100%",
    },
}));
const number = [1, 2, 3, 4, 5, 6];
const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    rtl: false,
};
const AboutUsCarousel = ({ imgs, loading }) => {
    const [production, setProduction] = useState(false)
    useEffect(() => {
        if (imgs) {
            setProduction(true)
        }
    }, [imgs])
    const classes = useStyles();
    return (
        <Slider {...settings}>
            {loading ? (number.map((i) => (
                <>
                    <div dir="rtl" style={{ margin: "10px" }}>
                        <Skeleton variant="rect" width="100%" height="100%" />
                    </div>
                </>
            ))) : (imgs.map((img, i) => (
                <div>
                    <Box m={1}>
                        <img src={imgs[i].imgURL} style={{ width: "100%" }} alt="" />
                    </Box>
                </div>
            )))}

        </Slider>
    );
};
export default AboutUsCarousel;
